export default function useStyles() {
  return {
    container: {
      position: 'relative',
    },
  };
}
